module.exports = require("miniprogram-computed");